import React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import {Typography} from '@mui/material';
import ErrorIcon from './ErrorIcon';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {hasError: true};
  }

  componentDidCatch(error, errorInfo) {
    // Auto-reload on chunk load failures (e.g. after a new deployment)
    if (
      error?.name === 'ChunkLoadError' ||
      /Loading chunk [\w\d]+ failed/i.test(error?.message) ||
      /Loading CSS chunk [\w\d]+ failed/i.test(error?.message)
    ) {
      const lastReload = sessionStorage.getItem('chunk_reload');
      const now = Date.now();
      // Prevent reload loops — only auto-reload once per 30 seconds
      if (!lastReload || now - Number(lastReload) > 30000) {
        sessionStorage.setItem('chunk_reload', String(now));
        window.location.reload();
        return;
      }
    }
    console.error(error, errorInfo, '::::::PROPS');
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              justifyContent: 'center',
              flex: 1,
              textAlign: 'center',
              '& svg': {
                width: '100%',
                maxWidth: 400,
                color: (theme) => theme.palette.primary.main,
              },
            }}
          >
            <ErrorIcon />
            <Typography
              variant='h2'
              component='h2'
              style={{fontSize: 30, marginTop: 16}}
            >
              Ah! Something went wrong.
            </Typography>
            <Typography style={{fontSize: 18, marginTop: 12}}>
              Brace yourself till we get the error fixed.
            </Typography>
            <Typography style={{fontSize: 18}}>
              You may also refresh the page or try again latter
            </Typography>
          </Box>
        </>
      );
    } else {
      return this.props.children;
    }
  }
}

export default AppErrorBoundary;

AppErrorBoundary.propTypes = {
  children: PropTypes.node,
};
